/* LFDM — page panier : le kit d'essai n'a pas de sélecteur de quantité.
   Le volet latéral est rendu par lfdm-cart.js ; ici on traite la page /cart
   rendue par le thème (une seule ligne de kit, quantité 1, retrait possible). */
(function () {
  if (!/^\/cart(\/|$)/.test(window.location.pathname)) return;

  var R = window.routes || {};
  var URL_CART = R.cart_url ? R.cart_url + '.js' : '/cart.js';
  var LAB = 'Quantité 1 · un seul kit par compte';
  var timer = null;

  function row(n) {
    var el = document.getElementById('CartItem-' + n);
    if (el) return el;
    var mark = document.querySelector('[data-index="' + n + '"]');
    if (!mark) return null;
    return mark.closest('tr') || mark.closest('.cart-item') || mark.closest('li');
  }

  function lock(items) {
    items.forEach(function (it, i) {
      if (!it.properties || !it.properties._kit) return;
      var r = row(i + 1);
      if (!r || r.getAttribute('data-lfdm-kit')) return;
      r.setAttribute('data-lfdm-kit', '1');
      var q = r.querySelector('quantity-input') || r.querySelector('.quantity');
      if (!q) return;
      var tag = document.createElement('p');
      tag.className = 'lfdm-kit-fix';
      tag.style.cssText = 'margin:0;font-size:1.3rem;line-height:1.35;opacity:.72';
      tag.textContent = LAB;
      q.parentNode.insertBefore(tag, q);
      q.style.display = 'none';
      var info = r.querySelector('.quantity-popover-info, .cart-item__quantity-rules, .quantity-popover__info');
      if (info) info.style.display = 'none';
    });
  }

  function run() {
    fetch(URL_CART, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { lock((j && j.items) || []); })
      .catch(function () {});
  }

  function soon() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(run, 160);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* le thème réinjecte la section du panier après chaque modification */
  var host = document.querySelector('cart-items') || document.getElementById('main-cart-items');
  if (host && window.MutationObserver) {
    new MutationObserver(soon).observe(host, { childList: true, subtree: true });
  }
})();
